import { z } from "zod";

export const multiSelectDefaultValuesSchema = z
  .array(
    z.object({
      value: z.string().uuid(),
      label: z.string(),
    }),
  )
  .optional();
